import moment from 'moment';
import {
  SET_BILLING_CALCULATION,
  SET_BILLING_REQUEST_KEY,
} from '../../constants';
import { getBillingCalculation as query } from '../../lib/graphql';

export const fetchBillingCalculation = ({
  listId,
  startDate,
  endDate,
  guests,
  convertCurrency,
  startTime,
  endTime,
  isDeliveryIncluded,
  promoCode,
  appliedPromoCode,
}) => {
  return async (dispatch, getState, { client }) => {
    const startKey = moment(startDate).format('YYYY-MM-DD');
    const endKey = moment(endDate).format('YYYY-MM-DD');
    const resolvedPromoCode =
      promoCode !== undefined
        ? (promoCode && String(promoCode).trim() ? String(promoCode).trim() : null)
        : (appliedPromoCode || null);
    const requestKey = [
      listId,
      startKey,
      endKey,
      guests || 1,
      convertCurrency,
      startTime,
      endTime,
      Boolean(isDeliveryIncluded),
      resolvedPromoCode || '',
    ].join('|');

    dispatch({
      type: SET_BILLING_REQUEST_KEY,
      payload: { billingRequestKey: requestKey, billingListId: listId },
    });

    try {
      const { data } = await client.query({
        query,
        variables: {
          listId,
          startDate: startKey,
          endDate: endKey,
          guests: guests || 1,
          convertCurrency,
          startTime,
          endTime,
          isDeliveryIncluded,
          promoCode: promoCode !== undefined ? promoCode : appliedPromoCode,
        },
        fetchPolicy: 'network-only',
      });

      // Ignore stale responses from a previous listing / date range.
      if (getState().book?.billingRequestKey !== requestKey) {
        return null;
      }

      if (data?.getBillingCalculation) {
        dispatch({
          type: SET_BILLING_CALCULATION,
          payload: {
            billingCalculation: data.getBillingCalculation,
            appliedPromoCode: resolvedPromoCode,
            billingListId: listId,
          },
        });
      }

      return data?.getBillingCalculation;
    } catch (error) {
      return null;
    }
  };
};
